export const destinations = {
    title: "Destinazioni",
    sortName: "Nome",
    noResults: "Nessun risultato",
    tryDifferentSearch: "Prova una ricerca diversa"
};
